import { HoursOfService } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultResponse } from "./types";

export interface HoursOfServiceUpdate {
  events: {
    id: number;
    type: string;
    start_date: string;
    end_date: string;
  }[];
  new_events?: {
    type: string;
    start_date: string;
    end_date: string;
  }[];
  reason: string;
}

export interface HoursOfServiceStore {
  vehicle_id: number;
  driver_id: number;
  events: {
    type: string;
    start_date: string;
    end_date: string;
  }[];
}

export type HoursOfServiceChangeAction = "created" | "updated" | "deleted";

export interface HoursOfServiceChangeFieldDiff {
  from: string | number | null;
  to: string | number | null;
}

export interface HoursOfServiceChangeEvent {
  action: HoursOfServiceChangeAction;
  type: string;
  start_date: string;
  end_date: string;
  changes: Record<string, HoursOfServiceChangeFieldDiff>;
}

export interface HoursOfServiceChange {
  id: number;
  hours_of_service_id: number;
  date: string;
  reason: string;
  user_id: number | null;
  user_name: string;
  events: HoursOfServiceChangeEvent[];
}

export const hoursOfServiceService = {
  async show(id: number) {
    const response = await api.get<DefaultResponse<HoursOfService, false>>(
      `/hours_of_service/${id}`,
    );
    return response.data;
  },

  async store(data: HoursOfServiceStore) {
    const response = await api.post<DefaultResponse<HoursOfService, false>>(
      "/hours_of_service",
      data,
    );
    return response.data;
  },

  async changes(id: number) {
    const response = await api.get<DefaultResponse<HoursOfServiceChange, true>>(
      `/hours_of_service/${id}/changes`,
    );
    return response.data;
  },

  async update(id: number, data: HoursOfServiceUpdate) {
    const response = await api.put<DefaultResponse<HoursOfService, false>>(
      `/hours_of_service/${id}`,
      data,
    );
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete<DefaultResponse<HoursOfService, false>>(
      `/hours_of_service/${id}`,
    );
    return response.data;
  },
};
